import Model from "../Model";

class DeleteUser extends Model{

    buildUrl ({ param }) {
        return ['/useradmin/delete', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }

    delete(form) {
        return this.request({
            action: 'destroy',
            method: 'POST',
            data: form
        });
    }
}


export default new DeleteUser;